import regionConfig from './regions.json';

// should not end with a slash
const tileServer = 'https://tiles.arcgis.com/tiles/C8EMgrsFcRFL6LrL/arcgis/rest/services/Tsunami_Evacuation_Zones/MapServer/tile';

// Legend config
// colorId maps to the layerId in the MapServer legend endpoint
const legend = {
    layerBaseUrl: 'https://tiles.arcgis.com/tiles/C8EMgrsFcRFL6LrL/arcgis/rest/services/Tsunami_Evacuation_Zones/MapServer',
    items: [
        { colorId: 6, name: 'Tsunami Evacuation Zone' },
        { colorId: 7, name: 'Extreme Tsunami Evacuation Zone' },
        { colorId: 8, name: 'Safe Zone' }
    ]
};

const tileOpacity = 0.5;

export { regionConfig as regions, tileServer, legend, tileOpacity };
